<template>
    <div class="section-block record-block">
        <div class="section-title">补材通知记录</div>
        <el-scrollbar class="timeline-scrollbar" v-loading="recordLoading">
            <el-timeline v-if="recordList.length">
                <el-timeline-item
                    v-for="(item, index) in recordList"
                    :key="item.id || index"
                    :timestamp="item.informDate"
                    placement="top"
                >
                    <template #dot>
                        <img src="@/assets/images/Investigation/timefille-icon.png" alt="" class="timeline-dot-img" />
                    </template>
                  <div class="timeline-container">
                    <div class="timeline-header">
                      <div>
                        {{item.informTypeName || ''}} - {{item.acceptorName||''}}
<!--                        <span>(文号：宝山人社材(2025)字第0001号)</span>-->
                      </div>
                      <p :style="{'background': item.status === 3 ? 'rgba(32, 201, 128, 0.1)' : 'rgba(255, 179, 34, 0.1)', 'color': item.status === 3 ? 'rgb(32, 201, 128)' : 'rgb(255, 179, 34)'}">  {{ item.status === 3 ? '已完成' :item.status==2?'部分已补充': '待补证' }}</p>
                    </div>
                    <div class="timeline-content">
                      <div class="txt-mark">
                        <p>需要补正的材料：{{item.identificationCaseMaterialContentList?.map((o) => o.materialContent).join('，') || '-'}}                          </p>
                        <p>补充说明：{{item.supplementaryInstruction ||''}}</p>
                      </div>
                      <div class="timeline-time">补材期限：{{item.deadline}}天(截止：{{item.deadlineTime}})</div>
                      <div class="timeline-card-actions">
                        <el-button type="primary" link size="small" @click="handleViewDetail(item)">查看详情</el-button>
<!--                        <el-button type="warning" link size="small" @click="handleEdit(item)">编辑</el-button>-->
<!--                        <el-button type="danger" link size="small" @click="handleDelete(item)">删除</el-button>-->
                      </div>
                    </div>
                  </div>
                </el-timeline-item>
            </el-timeline>
            <div v-else class="record-empty">暂无补材通知记录</div>
        </el-scrollbar>

        <el-dialog :visible.sync="detailVisible" title="补材通知详情" width="800px" append-to-body>
          <div class="dialog-container">
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span style="font-weight: 800;font-size: 16px">通知信息</span>
              </div>
              <el-form label-position="top" v-if="currentRecord">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="通知类型">
                      {{  currentRecord.informTypeName||''  }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="接收方">
                      {{  currentRecord.acceptorName||''  }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="通知日期">
                      {{  currentRecord.informDate||''  }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="补材期限">
                      {{ currentRecord.deadline }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="截止日期">
                      {{ currentRecord.deadlineTime }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="处理状态">
                      {{currentRecord.status === 3 ? '已完成' :currentRecord.status === 2?'部分已补充': '待补证' }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="完成日期">
                      {{ currentRecord.completeDate || '-' }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 20px;" v-if="currentRecord">
              <div slot="header" class="clearfix">
                <span style="font-weight: 800;font-size: 16px">补材内容</span>
              </div>
              {{ currentRecord.supplementaryInstruction || '-' }}
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 20px;" v-if="currentRecord">
              <div slot="header" class="clearfix">
                <span style="font-weight: 800;font-size: 16px">上传材料信息</span>
              </div>
              <div style="color:#1890ff ">
                {{currentRecord.acceptorName ||'-'}}上传材料
              </div>
              <div class="file-list">
                <div class="file-item" v-for="(i,ind) in currentRecord.identificationCaseMaterialContentList" :key="ind">
                  <div>{{i.materialContent}}</div>
                  <p>上传日期：{{ i.woundedPersonMaterialFileUrl?i.updateTime :'-' }} <span :class="[i.woundedPersonMaterialFileUrl?'upload-success':'upload-error']">{{i.woundedPersonMaterialFileUrl?'已上传':'未上传'  }}</span></p>
                </div>
              </div>
            </el-card>
          </div>
        </el-dialog>

        <el-dialog :visible.sync="editVisible" title="编辑补材通知" width="1000px" append-to-body @close="resetEditForm">
            <supplem :type="2" :rowData="currentRecord" v-if="editVisible"></supplem>
            <template #footer>
                <el-button @click="editVisible = false">取消</el-button>
                <el-button type="danger"  @click="handleEditSubmit">删除记录</el-button>
                <el-button type="primary" :loading="editLoading" @click="handleEditSubmit">保存修改</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { getListByDictType } from '@/api/sys/dictData'
import {getSupplementaryNotice} from '@/api/recognition/survey'
import supplem   from "@/views/pages/recognition/Investigation/components/supplem/index.vue";
export default {
    components: {
        supplem
    },
    name: 'SupplementRecordTimeline',
    data() {
        return {
            recordLoading: false,
            recordList: [],
            detailVisible: false,
            editVisible: false,
            currentRecord: null,
            editForm: {
                id: '',
                noticeType: '',
                receiver: '',
                deadlineDays: 7,
                remark: ''
            },
            formRules: {
                noticeType: [{ required: true, message: '请选择通知类型', trigger: 'change' }],
                receiver: [{ required: true, message: '请选择接收方', trigger: 'change' }],
                deadlineDays: [
                    { required: true, message: '请输入补材期限', trigger: 'blur' },
                    { type: 'number', min: 1, max: 365, message: '请输入 1-365 之间的天数', trigger: 'blur' }
                ]
            },
            noticeTypeOptions: [],
            receiverOptions: [],
            editLoading: false
        }
    },
    created() {
        this.loadDictData()
        this.loadRecordList()
    },
    methods: {
        async loadDictData() {
            const dictTypes = [
                { key: 'noticeTypeOptions', type: 'industrial_injury_supplement_notice_type' },
                { key: 'receiverOptions', type: 'industrial_injury_supplement_receiver' }
            ]
            for (const { key, type } of dictTypes) {
                try {
                    const res = await getListByDictType(type)
                    if (res && res.code === 200 && res.data) {
                        this[key] = res.data
                    }
                } catch (e) {
                    console.warn(`字典 ${type} 加载失败`, e)
                }
            }
        },
        loadRecordList() {
          let caseId = this.$route.query.id
          if (!caseId) return;
          this.recordLoading = true
          getSupplementaryNotice({caseId}).then(res => {
            if (res && res.code === 200 && res.data) {
              this.recordList = res.data
            }
          }).finally(() => {
            this.recordLoading = false
          })
            // setTimeout(() => {
            //     this.recordList = [
            //         {
            //             id: 1,
            //             createTime: '2024-08-19 10:30:20',
            //             title: '材料补正 - 用人单位',
            //             remark: '请补充工伤认定申请表、劳动关系证明材料',
            //             status: '1'
            //         },
            //         {
            //             id: 2,
            //             createTime: '2024-08-18 14:20:00',
            //             title: '证据补充 - 双方',
            //             remark: '请提供事发时的监控视频',
            //             status: '0'
            //         }
            //     ]
            // }, 300)
        },
        handleViewDetail(item) {
            this.currentRecord = item
            this.detailVisible = true
        },
        handleEdit(item) {
            this.currentRecord = item
            this.editForm = {
                id: item.id,
                noticeType: item.noticeType || '',
                receiver: item.receiver || '',
                deadlineDays: item.deadlineDays ?? 7,
                remark: item.remark || ''
            }
            this.editVisible = true
        },
        resetEditForm() {
            this.editForm = {
                id: '',
                noticeType: '',
                receiver: '',
                deadlineDays: 7,
                remark: ''
            }
            this.$refs.editFormRef?.resetFields()
        },
        handleEditSubmit() {
            this.$refs.editFormRef.validate((valid) => {
                if (!valid) return
                this.editLoading = true
                setTimeout(() => {
                    this.$message.success('保存成功')
                    this.editLoading = false
                    this.editVisible = false
                    this.loadRecordList()
                }, 400)
            })
        },
        handleDelete(item) {
            this.$confirm('确认删除该补材通知记录？', '提示', { type: 'warning' })
                .then(() => {
                    this.recordList = this.recordList.filter((r) => r.id !== item.id)
                    this.$message.success('删除成功')
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.section-block {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 0;

    .section-title {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        padding-left: 11px;
        margin-bottom: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 12px;
            border-radius: 20px;
            background: var(--vt-c-blue);
        }
    }
}

.record-block {
    display: flex;
    flex-direction: column;
    height: 100%;

    .section-title {
        flex-shrink: 0;
    }
}

.timeline-scrollbar {
    flex: 1;
    min-height: 320px;
    //max-height: calc(100vh - 280px);

    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
}

:deep(.el-timeline) {
    padding-left: 8px;
}

.timeline-dot-img {
    display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
    position: absolute;
    top: 46%;
    right: 65%;
    transform: translate(65%, -25%);
}

.timeline-card {
    padding: 12px 0;
}

.timeline-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.timeline-card-title {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
}

.timeline-card-desc {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 10px;
}

.timeline-card-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.record-empty {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
}
/deep/.el-timeline-item__tail {
  left: 2px;
  border: 0px;
  width: 2px;
  background-image:
      linear-gradient(to bottom, rgba(52, 139, 255, 1) 50%, transparent 50%);
  /* 第一个值=线宽，第二个值=段长+间距 */
  background-size: 1px 8px;
  background-repeat: repeat-y;
  background-position: center;
}
/deep/.el-timeline-item__timestamp{
  color: rgba(41, 125, 238, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0px;
  padding-top: 0px;
}
.timeline-container{
  margin-top: 12px;
  border-radius: 4px;
  background: rgba(247, 247, 247, 1);
  .timeline-header{
    padding: 12px;
    border-bottom: 1px solid rgba(233, 234, 236, 1);
    position: relative;
    >div{
      color: rgba(42, 51, 71, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      span{
        color: rgba(41, 125, 238, 1);
        font-family: OPPOSans;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        padding-left: 8px;
      }
    }
    >p{
      position: absolute;
      height: 24px;
      line-height: 24px;
      border-radius:  100px 0px 0px 100px;
      background: rgba(32, 201, 128, 0.1);
      min-width: 66px;
      top: 50%;
      transform: translateY(-50%);
      right: 0px;
      color: rgba(32, 201, 128, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      padding: 2px 12px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
    }
  }
  .timeline-content{
    padding: 12px;
    .txt-mark{
      color: rgba(70, 77, 90, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
    .timeline-time{
      margin-top: 12px;
      color: rgba(255, 62, 80, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
    }
    .timeline-card-actions{
      margin-top: 16px;
    }
  }
}
.dialog-container{
  flex: 1;
  height: 60vh;
  //display: flex;
  //flex-flow: column;
  overflow-y: auto;
}
.file-list{
  //border: 1px solid;
  margin-top: 12px;
  .file-item{
    display: flex;
    margin-bottom: 12px;
    >div{
      flex: 1;
      word-break: break-all;
      margin-right: 10px;
    }
    p{
      span{
        display: inline-block;
        padding: 0px 6px;
        border-radius: 10px;
        margin-left: 4px;
      }
      .upload-success{
        background-color: #f6ffed;
        color: #52c41a;
        border: 1px solid #b7eb8f;
      }
      .upload-error{
      background-color: #fff3f3;
        color: #f56c6c;
        border: 1px solid #fde2e2;
      }
    }
  }
}
</style>
